import dayjs from 'dayjs';
import moment from 'moment';
export const getInstallerTimeDetails = dateString => {
  const time = moment(dateString);

  const morningStart = time.clone().set({ hour: 8, minute: 0, second: 0 });
  const morningEnd = time.clone().set({ hour: 12, minute: 0, second: 0 });

  const afternoonStart = time.clone().set({ hour: 12, minute: 0, second: 1 });
  const afternoonEnd = time.clone().set({ hour: 16, minute: 59, second: 59 });

  const eveningStart = time.clone().set({ hour: 17, minute: 0, second: 0 });
  const eveningEnd = time.clone().set({ hour: 20, minute: 0, second: 0 });

  if (time.isBetween(morningStart, morningEnd, null, '[]')) {
    return { startTime: '08:00:00', endTime: '12:00:00' };
  } else if (time.isBetween(afternoonStart, afternoonEnd, null, '[]')) {
    return { startTime: '12:00:01', endTime: '17:00:00' };
  } else if (time.isBetween(eveningStart, eveningEnd, null, '[]')) {
    return { startTime: '17:00:00', endTime: '18:00:00' };
  }

  return null;
};

const parseTime = timeStr => {
  if (!timeStr || typeof timeStr !== 'string') {
    return { hours: 0, minutes: 0 };
  }

  const [time, meridian] = timeStr.split(' ');
  if (!time || !meridian) {
    return { hours: 0, minutes: 0 };
  }
  let [hours, minutes] = time.split(':').map(Number);

  if (meridian === 'PM' && hours !== 12) hours += 12;
  if (meridian === 'AM' && hours === 12) hours = 0;

  return { hours, minutes };
};
export const applySlotTimesToDates = (startDate, endDate, slotValue) => {
  if (!slotValue) {
    return {
      startTime: startDate ? dayjs(startDate) : null,
      endTime: endDate ? dayjs(endDate) : null,
    };
  }

  const [startTimeString, endTimeString] = slotValue
    .split('-')
    .map(v => v.trim());

  const startTime = parseTime(startTimeString);
  const endTime = parseTime(endTimeString);

  let updatedStartDate = startDate ? dayjs(startDate) : dayjs();
  let updatedEndDate = endDate ? dayjs(endDate) : dayjs();

  updatedStartDate = updatedStartDate
    ?.hour(startTime.hours)
    ?.minute(startTime.minutes)
    ?.second(0)
    ?.millisecond(0);

  updatedEndDate = updatedEndDate
    ?.hour(endTime.hours)
    ?.minute(endTime.minutes)
    ?.second(0)
    ?.millisecond(0);

  return {
    startTime: updatedStartDate.toDate(),
    endTime: updatedEndDate.toDate(),
  };
};

export const formatTimeToHHMMSS = date => {
  if (!date) return '';

  const parsed = dayjs(date);

  return parsed.isValid() ? parsed.format('HH:mm:ss') : '';
};
